import React from "react";

import { InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { NOTIFICATION_TYPE } from "@src/constants";
import { Alert } from "antd";
import "./notification_banner.less";

interface NotificationBannerProps {
  type: NOTIFICATION_TYPE.INFO | NOTIFICATION_TYPE.WARNING;
  message: React.ReactNode;
  action?: React.ReactNode;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  type,
  message,
  action,
}) => {
  return (
    <Alert
      className="notification-banner"
      icon={
        type === NOTIFICATION_TYPE.INFO ? (
          <InfoCircleOutlined />
        ) : (
          <WarningOutlined />
        )
      }
      message={message}
      type={type}
      action={action}
      showIcon
    />
  );
};

export default NotificationBanner;
